import React, { useCallback, useEffect } from 'react';

import { downloadSettingExcel } from "src/utils/blob/blobUtil";


import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import useUiuxStore, { PUR1020_PUR1030NavigationData, PUR1020_WMS1130NavigationData, Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';
import { PUR1020_R01Filter, usePUR1020_R01Store } from './Store_PUR1020_R01';

import { AgGridReact } from 'ag-grid-react';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { downloadExcel_PUR1020_R01, getPUR1020_R01AllCount, getPUR1020_R01List, getPUR1020_R01Purchase, getPUR1020_R01Supplied } from "./Api_PUR1020_R01";
import { PUR1020_R01HeaderDto, PUR1020_R01PurchaseDto } from './Dto_PUR1020_R01';
import { getFutureWeekdayExceptTodayAndTomorrow } from 'src/utils/date/dateUtils';
import { getMenuComponent } from 'src/utils/menu/menuUtil';
import { useWMS1130_R01Store } from '../../WMS/WMS1130_R01/Store_WMS1130_R01';
import { formatDate } from 'src/utils/string/stringUtil';

interface Props {
    gridRef: React.RefObject<AgGridReact<PUR1020_R01HeaderDto> | null>;
    purchaseGridRef: React.RefObject<AgGridReact<PUR1020_R01PurchaseDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}

export const Content_PUR1020_R01 = (props: Props) => {

	const {
		gridRef, purchaseGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	
    const {
        PUR1020_R01Filter, setPUR1020_R01Filter,
        PUR1020_R01PastFilter, setPUR1020_R01PastFilter,
        PUR1020_R01List, setPUR1020_R01List,
        selectedPUR1020_R01, setSelectedPUR1020_R01, 
        PUR1020_R01PurchaseList, setPUR1020_R01PurchaseList,
        deletedPUR1020_R01PurchaseList, setDeletedPUR1020_R01PurchaseList, addDeletedPUR1020_R01PurchaseList, removeDeletedPUR1020_R01PurchaseList, 
        selectedPUR1020_R01PurchaseList, setSelectedPUR1020_R01PurchaseList, addSelectedPUR1020_R01PurchaseList, removeSelectedPUR1020_R01PurchaseList,
        originalPUR1020_R01PurchaseList, setOriginalPUR1020_R01PurchaseList,
        PUR1020_R01SuppliedList, setPUR1020_R01SuppliedList,
        deletedPUR1020_R01SuppliedList, setDeletedPUR1020_R01SuppliedList, addDeletedPUR1020_R01SuppliedList, removeDeletedPUR1020_R01SuppliedList, 
        selectedPUR1020_R01SuppliedList, setSelectedPUR1020_R01SuppliedList, addSelectedPUR1020_R01SuppliedList, removeSelectedPUR1020_R01SuppliedList,
        originalPUR1020_R01SuppliedList, setOriginalPUR1020_R01SuppliedList,
        allCount, setAllCount,
        initData,
        setScrollTop, setPurchaseScrollTop, setSuppliedScrollTop,
    } = usePUR1020_R01Store();

	const { 
		PUR1020_PUR1030NavigationData, setPUR1020_PUR1030NavigationData,
		PUR1020_WMS1130NavigationData, setPUR1020_WMS1130NavigationData,
		addTabList, setActiveTab
	} = useUiuxStore();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { vatTypeList, itemStatusList, inoutMethodList, customCdList } = useCommonCodeStore();

	const { 
		warehouseCdListToUseList : WMS1130_R01WarehouseCdListToUseList,
	} = useWMS1130_R01Store();

    useFetchActionbarAuth("PUR1020_R01");

    const getParams = (filter: PUR1020_R01Filter) => {
        const params: Partial<PUR1020_R01Filter> = {
			compCd: filter.compCd || undefined,
			itemGroup: filter.itemGroup || undefined,
			brandCd: filter.brandCd || undefined,
			customCd: filter.customCd || undefined,
			itemCd: filter.itemCd || undefined,
			dateRange: filter.dateRange || undefined,
			logicCenter: filter.logicCenter || undefined,
		};
		return params;
	}

	const getConditionList = useCallback((list: PUR1020_R01HeaderDto[]) => {
		return list.map((condition: PUR1020_R01HeaderDto) => {
			return `${condition.salesOrderNo}_%_${condition.itemCd}`;
		});
	}, []);

	const handleExcelClick = useCallback(async () => {
		const conditionList = getConditionList(PUR1020_R01List);

        if(conditionList.length === 0){
			showWarning("엑셀 다운로드할 데이터가 없습니다.");
			return;
		}

		setLoadingSpinner(true);

        const response = await downloadExcel_PUR1020_R01(conditionList);

		downloadSettingExcel({ responseData: response.data.data, fileName: 'MRP 전개 현황-excel.xlsx' });

		setLoadingSpinner(false);
    }, [PUR1020_R01List, getConditionList, setLoadingSpinner])

	const renewalAllCount = useCallback(async () => {
        const response = await getPUR1020_R01AllCount(getParams(PUR1020_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
    }, [PUR1020_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		setScrollTop(null);
		setPurchaseScrollTop(null);
		setSuppliedScrollTop(null);
		setLoadingSpinner(true);
	
        const responseData = (await getPUR1020_R01List(
			'',
            getParams(PUR1020_R01Filter),
			PUR1020_R01List.length ?? 0
		));


        let newList = [ ...responseData.data.data.map((value: any) => ({
			...value,
			salesOrderItemNo: value.salesOrderNo + '-' + value.itemNo,
		})) ] as PUR1020_R01HeaderDto[];
		setPUR1020_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
            gridRefSelectedRowHandler(
                gridRef,
                setSelectedPUR1020_R01,
                () => true,// 유지
            );
            setPUR1020_R01PastFilter(PUR1020_R01Filter);
			setLoadingSpinner(false);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총${newList.length}/${processAllCount}건)`);
		}else {
			showWarning('데이터가 없습니다.');
            setSelectedPUR1020_R01(undefined);
            setPUR1020_R01List([]);
            setPUR1020_R01PurchaseList([]); 
            setDeletedPUR1020_R01PurchaseList([]);
            setSelectedPUR1020_R01PurchaseList([]);
            setOriginalPUR1020_R01PurchaseList([]);
			setPUR1020_R01SuppliedList([]);
			setDeletedPUR1020_R01SuppliedList([]);
			setSelectedPUR1020_R01SuppliedList([]);
			setOriginalPUR1020_R01SuppliedList([]);
			setLoadingSpinner(false);
		}
        return newList;
    }, [PUR1020_R01Filter, PUR1020_R01List, setPUR1020_R01List, setPUR1020_R01PastFilter, setSelectedPUR1020_R01, selectedPUR1020_R01, setScrollTop, setPurchaseScrollTop, setSuppliedScrollTop])
	

	const fetchPurchaseData = useCallback(async (conditionList: string[]) => {
		setPurchaseScrollTop(null);
		try {
			const response = await getPUR1020_R01Purchase(conditionList);
			
			if (response.data.successFlag && response.data.data) {
				const responseData = response.data.data;
				
				if(responseData && responseData.length > 0){
					const processedData = responseData.map((value: any, idx: number) => ({
						...value,
						valueIndex: value.valueIndex ?? idx + 1,
						orderIndex: value.orderIndex ?? idx + 1,
						orderIndexSeq: value.orderIndexSeq ?? 0,
					}));
					
					setPUR1020_R01PurchaseList(processedData);
					setOriginalPUR1020_R01PurchaseList(responseData);
					setMessage(`${selectedPUR1020_R01?.customNm}의 상세내역 ${responseData.length}건을 조회하였습니다.`);
					setTimeout(() => setMessage(""), 5000);
				} else {
					// 조회용: 데이터가 없으면 빈 배열만 설정
					setPUR1020_R01PurchaseList([]);
					setOriginalPUR1020_R01PurchaseList([]);
					setMessage("상세내역이 없습니다.");
					setTimeout(() => setMessage(""), 3000);
				}
			} else {
				// API 응답 실패 처리
				showError('상세내역 조회에 실패했습니다.');
				setPUR1020_R01PurchaseList([]);
				setOriginalPUR1020_R01PurchaseList([]);
			}
		} catch (error) {
			console.error('상세내역 조회 오류:', error);
			showError('상세내역 조회 중 오류가 발생했습니다.');
			setPUR1020_R01PurchaseList([]);
			setOriginalPUR1020_R01PurchaseList([]);
		}
	}, [selectedPUR1020_R01?.customNm, setPUR1020_R01PurchaseList, setOriginalPUR1020_R01PurchaseList, setPurchaseScrollTop, setMessage]);

	const fetchSuppliedData = useCallback(async (conditionList: string[]) => {
		setSuppliedScrollTop(null);
		try {
			const response = await getPUR1020_R01Supplied(conditionList);
			
			if (response.data.successFlag && response.data.data) {
				const responseData = response.data.data;
				
				if(responseData && responseData.length > 0){
					const processedData = responseData.map((value: any, idx: number) => ({
						...value,
						valueIndex: value.valueIndex ?? idx + 1,
						orderIndex: value.orderIndex ?? idx + 1,
						orderIndexSeq: value.orderIndexSeq ?? 0,
					}));
					
					setPUR1020_R01SuppliedList(processedData);
					setOriginalPUR1020_R01SuppliedList(responseData);
					setMessage(`${selectedPUR1020_R01?.itemNm}의 자재내역 ${responseData.length}건을 조회하였습니다.`);
					setTimeout(() => setMessage(""), 5000);
				} else {
					// 조회용: 데이터가 없으면 빈 배열만 설정
					setPUR1020_R01SuppliedList([]);
					setOriginalPUR1020_R01SuppliedList([]);
					setMessage("자재내역이 없습니다.");
					setTimeout(() => setMessage(""), 3000);
				}
			} else {
				// API 응답 실패 처리
				showError('상세내역 조회에 실패했습니다.');
				setPUR1020_R01SuppliedList([]);
				setOriginalPUR1020_R01SuppliedList([]);
			}
		} catch (error) {
			console.error('상세내역 조회 오류:', error);
			showError('상세내역 조회 중 오류가 발생했습니다.');
			setPUR1020_R01SuppliedList([]);
			setOriginalPUR1020_R01SuppliedList([]);
		}
	}, [selectedPUR1020_R01?.itemNm, setPUR1020_R01SuppliedList, setOriginalPUR1020_R01SuppliedList, setSuppliedScrollTop, setMessage]);

	const handleFetchClick = useCallback(async () => { 
		const response = await fetchData();
		const conditionList = getConditionList(response);

		if(conditionList.length > 0){
			fetchSuppliedData(conditionList);
			fetchPurchaseData(conditionList);
		}
	}, [fetchData, fetchSuppliedData, fetchPurchaseData, getConditionList]);


	
	// MRP전개 → 발주 처리: PUR1030_R01로 네비게이션 데이터 전달 후 탭 오픈
	const handlePUR1030ProcessClick = useCallback(async () => {
		if (!selectedPUR1020_R01) {
			showWarning("발주 처리할 수주를 선택해주세요.");
			return;
		}

		// 발주필요량이 0이상인 도급자재 데이터 필터링
		const purchaseList = PUR1020_R01PurchaseList.filter(value => value.requiredPurchaseQty > 0);
		if (purchaseList.length === 0) {
			showWarning("발주필요량이 0이상인 도급자재가 없습니다.");
			return;
		}

		//거래처 정보 가져와서 전화번호, e-mail, 팩스번호, 기준화폐 가져오기


		try{

			const customInfo = customCdList.find(value => value.customCd === selectedPUR1020_R01?.customCd);
			if (!customInfo) {
				showWarning("거래처 정보를 찾을 수 없습니다.");
				return;
			}


			let purchaseNavigationData: PUR1020_PUR1030NavigationData = {
				purchaseOrderHeaderDto: {
					valueIndex: 0,
					orderIndex: 0,
					orderIndexSeq: 0,

					purchaseOrderNo: '',
					compCd: selectedPUR1020_R01?.compCd,
					compNm: '',
					orderDt: selectedPUR1020_R01?.orderDt || formatDate(new Date()),
					customCd: selectedPUR1020_R01?.customCd,
					customNm: selectedPUR1020_R01?.customNm,
					vatType: vatTypeList[0].minorCd,
					totBaseVat: 'N',
					empNo: '',
					empNm: '',
					logicCenter: selectedPUR1020_R01?.logicCenter,
					orderAmt: 0,
					vatAmt: 0,
					totalAmt: 0,
					moneyCd: customInfo.moneyCd,
					dueDt: formatDate(getFutureWeekdayExceptTodayAndTomorrow()),
					telNo: customInfo.telNo,
					faxNo: customInfo.faxNo,
					email: customInfo.taxEmail,
					approveFlg: 'N',
					orderStatus: '',
					remark: '',	

					post: customInfo.post,
					address: customInfo.address,
					otherAddress: customInfo.detailAddress,

					inserted: false,
					isModified: false,
				},
				purchaseOrderDetailDtoList: purchaseList.map(value => ({
					
					...value,

					purchaseOrderNo: '',
					itemNo: '',
					itemCd: value.childItemcd,
					itemNm: value.childItemnm,
					itemSpec: value.itemSpec,	//
					modelNo: value.modelNo,		//
					compCd: selectedPUR1020_R01?.compCd,
					orderDt: selectedPUR1020_R01?.orderDt || formatDate(new Date()),
					customCd: selectedPUR1020_R01?.customCd,
					itemSeq: 0,
					//발주필요량이 발주등록에 들어갈 각 자재의 수량량
					orderQty: value.requiredPurchaseQty,
					cancelQty: 0,
					orderUnit: value.childItemUnit,
					orderPrice: value.orderPrice,
					dcAmt: 0,
					itemAmt: value.requiredPurchaseQty * value.orderPrice,
					remark: '',
					
					completeTransport: 0,

					inserted: true,
					isModified: false,
				})),
			};

			setPUR1020_PUR1030NavigationData(purchaseNavigationData);

			// PUR1030_R01 탭 열기
			const pur1030Component = getMenuComponent('PUR1030_R01');
			if (pur1030Component) {
				const newTab = {
					key: 'PUR1030_R01',
					title: '발주 등록',
					component: pur1030Component,
					fixed: false
				};
				
				// 탭 추가 및 활성화
				addTabList(newTab);
				setActiveTab(newTab);
				
				// showSuccess("MRP 전개 데이터가 수주 등록 화면으로 전달되었습니다.");
			} else {
				showError("수주정보등록 화면을 찾을 수 없습니다.");
			}

		}catch(error){
			console.error('발주 처리 오류:', error);
			showError('발주 처리 중 오류가 발생했습니다.');
		}

	}, [selectedPUR1020_R01, PUR1020_R01PurchaseList])

	// MRP전개 → 사급품 입고등록 처리: WMS1130_R01로 네비게이션 데이터 전달 후 탭 오픈
	const handleWMS1130ProcessClick = useCallback(async () => {
		if (!selectedPUR1020_R01) {
			showWarning("사급품 입고등록 처리할 수주를 선택해주세요.");
			return;
		}

		// 사급품필요량이 0이상인 도급자재 데이터 필터링
		const suppliedList = PUR1020_R01SuppliedList.filter(value => value.orderQty > 0);
		if (suppliedList.length === 0) {
			showWarning("사급품필요량이 0이상인 사급자재가 없습니다.");
			return;
		}

		//거래처 정보 가져와서 전화번호, e-mail, 팩스번호, 기준화폐 가져오기


		try{

			const customInfo = customCdList.find(value => value.customCd === selectedPUR1020_R01?.customCd);
			if (!customInfo) {
				showWarning("거래처 정보를 찾을 수 없습니다.");
				return;
			}


			let wmsNavigationData: PUR1020_WMS1130NavigationData = {
				wmsTransportHeaderDto: {
					valueIndex: 0,
					orderIndex: 0,
					orderIndexSeq: 0,

					transportNo: '',
					compCd: selectedPUR1020_R01?.compCd,
					compNm: '',
					logicCenter: selectedPUR1020_R01?.logicCenter,
					transportDt: selectedPUR1020_R01?.orderDt || formatDate(new Date()),
					warehouseCd: WMS1130_R01WarehouseCdListToUseList(selectedPUR1020_R01?.logicCenter || '')[0]?.warehouseCd || '',
					warehouseNm: '',
					inoutType: 'IN',
					inoutClass: '170',
					customCd: selectedPUR1020_R01?.customCd,
					customNm: selectedPUR1020_R01?.customNm,
					otherLogicCenter: '',
					inoutMethod: inoutMethodList[0] ? inoutMethodList[0].minorCd : '',
					empNo: '',
					empNm: '',
					transAmt: 0,
					vatAmt: 0,
					totalAmt: 0,
					telNo: customInfo.telNo,
					faxNo: customInfo.faxNo,
					email: customInfo.taxEmail,
					post: customInfo.post,
					address: customInfo.address,
					otherAddress: customInfo.detailAddress,
					trackingNo: '',
					approveFlg: '',
					remark: '',

					inserted: false,
					isModified: false,
				},
				wmsTransportDetailDtoList: suppliedList.map(value => {

					return {
						...value,

						transportNo: '',
						itemNo: '',
						compCd: selectedPUR1020_R01?.compCd,
						compNm: '',
						logicCenter: selectedPUR1020_R01?.logicCenter,
						transportDt: selectedPUR1020_R01?.orderDt || formatDate(new Date()),
						inoutType: '',
						itemCd: value.childItemcd,
						itemNm: value.childItemnm,
						itemSpec: value.itemSpec,	//
						itemStatus: itemStatusList[0].minorCd,
						unit: value.childItemUnit,
						//bom소요량 * selectedPUR1020_R01의 주문량이 사급품 입고등록의 각 자재에 들어갈 수량
						qty: value.orderQty,
						cost: value.orderPrice,
						amt: value.orderQty * value.orderPrice,
						basOrderType: '',
						basOrderNo: '',
						basOrderItemNo: '',
						remark: '',
						
						lotNo: '',
						printed: false,
						locationCd: '',
						locationNm: '',

						inserted: true,
						isModified: false,
					};
				}),
			};

			setPUR1020_WMS1130NavigationData(wmsNavigationData);

			// PUR1030_R01 탭 열기
			const wms1130Component = getMenuComponent('WMS1130_R01');
			if (wms1130Component) {
				const newTab = {
					key: 'WMS1130_R01',
					title: '사급품 입고등록',
					component: wms1130Component,
					fixed: false
				};
				
				// 탭 추가 및 활성화
				addTabList(newTab);
				setActiveTab(newTab);
				
				// showSuccess("MRP 전개 데이터가 사급품 입고등록 화면으로 전달되었습니다.");
			} else {
				showError("사급품 입고등록 화면을 찾을 수 없습니다.");
			}

		}catch(error){
			console.error('사급품 입고등록 오류:', error);
			showError('사급품 입고등록 중 오류가 발생했습니다.');
		}

	}, [selectedPUR1020_R01, PUR1020_R01SuppliedList])

	// 조회용: 신규행 추가 로직 제거
	
	return {
		handleExcelClick,
		handleFetchClick,
		handlePUR1030ProcessClick,
		handleWMS1130ProcessClick,
	};
}
